module.exports = __webpack_public_path__ + "asset/image/antena-11ed.svg";